<template>
	<v-card>
		<v-card-title class="py-2 primary">
			<span class="tertiary--text">Aggiungi codice SDI</span>
		</v-card-title>
		<v-card-text>
			<v-row class="mt-4">
				<v-col>
					<v-text-field
						v-model="codiceSDIComputed"
						label="Codice SDI"
						outlined
						dense
						:rules="[mixin_rules.codice_sdi]"
					></v-text-field>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-alert
				v-model="showAlert"
				type="warning"
				color="error"
				icon="mdi-alert-outline"
				transition="cale-transition"
				dense
				class="mb-0 mr-6"
			>
				{{ alertMessage }}
			</v-alert>
			<v-btn
				color="tertiary"
				@click="close()"
				:disabled="saving"
				class="black--text"
			>
				Annulla
			</v-btn>
			<v-btn
				color="secondary"
				@click="save()"
				:loading="saving"
			>
				Aggiungi
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {mapGetters} from "vuex";

export default {
	props: [
	
	],
	
	data() {
		return {
			saving: false,
			codiceSDI: null,
			showAlert: false,
			alertMessage: null
		}
	},
	
	computed: {
		codiceSDIComputed: {
			get() {
				return this.codiceSDI;
			},
			set(value) {
				this.codiceSDI = value.toUpperCase();
			}
		}
	},
	
	methods: {
		save() {
			this.saving = true;
			
			axios.post('/api/codici-sdi', {
				codice: this.codiceSDI
			},{
				dontShowSystemSnackbar: true
			})
				.then(response => {
					this.$emit('codice-sdi-aggiunto', response.data);
					this.close();
				})
				.catch(error => {
					if (error.response) {
						this.alertMessage = error.response.data.error;
						this.showAlert = true;
						
						setTimeout(() => {
							this.showAlert = false;
						}, 5000)
					}
					
				})
				.finally(() => {
					this.saving = false;
				})
		},
		close() {
			this.$emit('close');
		}
	}
}
</script>